import { RC_MODULE_PREFIX } from '../constants';
export const FILE_UPLOAD_RC_ALL_FILES_UPLOAD_START = `${RC_MODULE_PREFIX}_RC_ALL_FILES_UPLOAD_START`;
export const FILE_UPLOAD_RC_RETRY_FILES_UPLOAD_START = `${RC_MODULE_PREFIX}_RC_RETRY_FILES_UPLOAD_START`;
export const FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_START = `${RC_MODULE_PREFIX}_RC_SINGLE_FILE_UPLOAD_START`;
export const FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_COMPLETE = `${RC_MODULE_PREFIX}_RC_SINGLE_FILE_UPLOAD_COMPLETE`;
export const FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_PROGRESS = `${RC_MODULE_PREFIX}_RC_SINGLE_FILE_UPLOAD_PROGRESS`;
export const FILE_UPLOAD_RC_SCALE_IMAGE_COMPLETE = `${RC_MODULE_PREFIX}_RC_SCALE_IMAGE_COMPLETE`;
export const FILE_UPLOAD_RC_ADD_SINGLE_FILE = `${RC_MODULE_PREFIX}_RC_ADD_SINGLE_FILE`;
export const FILE_UPLOAD_RC_ALL_FILES_UPLOAD_SUCCESS = `${RC_MODULE_PREFIX}_RC_ALL_FILES_UPLOAD_SUCCESS`;
export const FILE_UPLOAD_RC_CLOSE_MODAL = `${RC_MODULE_PREFIX}_RC_CLOSE_MODAL`;
export const FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_CANCEL = `${RC_MODULE_PREFIX}_RC_SINGLE_FILE_UPLOAD_CANCEL`;
export const allRCFilesUploadStartAction = uploadFilesActionPayload => ({
    type: FILE_UPLOAD_RC_ALL_FILES_UPLOAD_START,
    payload: uploadFilesActionPayload
});
export const retryRCFilesUploadStartAction = uploadFilesActionPayload => ({
    type: FILE_UPLOAD_RC_RETRY_FILES_UPLOAD_START,
    payload: uploadFilesActionPayload
});
export const allRCFilesUploadSuccessAction = () => ({
    type: FILE_UPLOAD_RC_ALL_FILES_UPLOAD_SUCCESS,
    payload: {}
});
export const closeRCFileUploadModalAction = () => ({
    type: FILE_UPLOAD_RC_CLOSE_MODAL,
    payload: {}
});
export const singleRCFileUploadStartAction = id => ({
    type: FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_START,
    payload: { id }
});
export const singleRCFileUploadCompleteAction = payload => ({
    type: FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_COMPLETE,
    payload: payload
});
export const singleRCFileUploadProgressAction = payload => ({
    type: FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_PROGRESS,
    payload: payload
});
export const scaleRCImageCompleteAction = (id, success, file) => ({
    type: FILE_UPLOAD_RC_SCALE_IMAGE_COMPLETE,
    payload: { id, success, file }
});
export const addRCSingleFileAction = fileInfo => ({
    type: FILE_UPLOAD_RC_ADD_SINGLE_FILE,
    payload: { fileInfo: fileInfo }
});
export const singleRCFileUploadCancelAction = id => ({
    type: FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_CANCEL,
    payload: { id }
});
//# sourceMappingURL=RCFileUploadActions.js.map